import { Theme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";
import { StyleSheet } from "@react-pdf/renderer";

import VoTheme from "ui/theme/vocollege2";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flex: 1,
      flexDirection: "column",

      // alignItems: "stretch",
      // display: "flex",
      // flex: 1,
      // font: "16px/20px Garamond",
      // maxWidth: "100%",
      // padding: theme.spacing(4),
    },
    wrapper: {
      border: `3px solid ${theme.palette.primary.main}`,
      borderRadius: theme.shape.borderRadiusBig,
      flex: 1,
      maxWidth: "100%",
      paddingTop: "10%",
      position: "relative",
      textAlign: "center",
    },
    // logo: {
    //   marginLeft: "auto",
    //   marginRight: "auto",
    //   width: "17%",
    // },
    // logoPlaceholder: {
    //   alignItems: "center",
    //   border: `1px solid ${theme.palette.grey[100]}`,
    //   display: "flex",
    //   flexDirection: "column",
    //   height: "22%",
    //   justifyContent: "center",
    //   marginLeft: "auto",
    //   marginRight: "auto",
    //   padding: theme.spacing(1),
    //   width: "22%",
    // },
    // logoPlaceholderTitle: {},
    // logoPlaceholderSubtitle: {
    //   lineHeight: "1.2em",
    // },
    title: {},
    name: {},
    personalNumber: {},
    row: {},
    signatures: {
      display: "flex",
      marginLeft: "auto",
      marginRight: "auto",
      width: "70%",
    },
    signature: {
      borderTop: `1px solid ${theme.palette.common.black}`,
      flex: 1,
      fontSize: "60%",
      lineHeight: "1.3em",
      marginLeft: "2%",
      marginRight: "2%",
    },
    signaturePerson: {},
    signatureTitle: {},
    certifiedSince: {
      fontSize: "60%",
      fontStyle: "italic",
    },
    footer: {
      border: "1px solid red",
      bottom: 0,
      left: 0,
      position: "absolute",
      right: 0,
    },
  })
);

export const styles = StyleSheet.create({
  page: {
    fontFamily: "Lucida Grande",
    padding: VoTheme.spacing(4),
  },
  decor: {
    border: `5px solid ${VoTheme.palette.primary.main}`,
    borderTopLeftRadius: VoTheme.shape.borderRadiusBig,
    borderTopRightRadius: VoTheme.shape.borderRadiusBig,
    borderBottomRightRadius: VoTheme.shape.borderRadiusBig,
    borderBottomLeftRadius: VoTheme.shape.borderRadiusBig,
    height: "100%",
    padding: `${VoTheme.spacing(2)} ${VoTheme.spacing(4)}`,
    width: "100%",
  },
  logoWrapper: {
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    marginBottom: 0,
    marginTop: 0,
  },
  logo: {
    height: "auto",
    width: 80,
  },
  title: {
    color: VoTheme.palette.common.black,
    fontSize: 36,
    fontWeight: 700,
    textAlign: "center",
    textTransform: "uppercase",
  },
  subtitleWrapper: {
    borderTop: `1px solid ${VoTheme.palette.common.black}`,
    marginTop: VoTheme.spacing(2),
    paddingTop: VoTheme.spacing(2),
  },
  subtitle: {
    color: VoTheme.palette.common.black,
    fontSize: 18,
    fontWeight: 700,
    textAlign: "center",
  },
  person: {
    // fontFamily: "Times-Italic",
    fontSize: 20,
    // fontWeight: 500,
    textAlign: "center",
  },
  // personalNumber: {
  //   // fontFamily: "Times-Roman",
  //   fontSize: 16,
  //   marginTop: VoTheme.spacing(1),
  //   textAlign: "center",
  // },
  block2: {
    marginTop: VoTheme.spacing(2),
  },
  block3: {
    marginTop: VoTheme.spacing(3),
  },
  // block4: {
  //   marginTop: VoTheme.spacing(2),
  // },
  centeredText: {
    fontSize: 12,
    marginTop: VoTheme.spacing(1.5),
    textAlign: "center",
  },
  diplomaTextWrapper: {
    marginTop: VoTheme.spacing(2),
    paddingTop: VoTheme.spacing(2),
  },
  // diplomaText: {
  //   borderTop: `1px solid ${VoTheme.palette.common.black}`,
  //   paddingTop: VoTheme.spacing(4),
  // },
  text: {
    fontSize: 9,
    lineHeight: 1.3,
    marginTop: VoTheme.spacing(0.5),
    textAlign: "left",
  },
  // textCollege: {
  //   textAlign: "center",
  //   textTransform: "uppercase",
  // },
  date: {
    textAlign: "center",
  },
  signatures: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    paddingLeft: VoTheme.spacing(7),
    paddingRight: VoTheme.spacing(7),
    width: "100%",
  },
  signature: {
    borderTop: `1px solid ${VoTheme.palette.common.black}`,
    flex: 1,
    marginLeft: VoTheme.spacing(2),
    marginRight: VoTheme.spacing(2),
    maxWidth: 200,
    paddingTop: VoTheme.spacing(0.5),
  },
  signaturePerson: {
    fontSize: 10,
    textAlign: "center",
  },
  signatureTitle: {
    fontSize: 10,

    marginTop: VoTheme.spacing(0.5),
    textAlign: "center",
  },
  // educatorCertified: {
  //   marginTop: VoTheme.spacing(4),
  // },

  footer: {
    alignItems: "center",
    display: "flex",
    // flexWrap: "nowrap",
    flexDirection: "row",

    marginTop: VoTheme.spacing(3),

    // fontSize: 10,
    // marginBottom: VoTheme.spacing(2),
    // marginTop: VoTheme.spacing(8),
    // textAlign: "center",
  },

  // footerLogoWrapper: {
  //   alignItems: "flex-end",
  //   display: "flex",
  //   flexDirection: "column",
  //   margin: VoTheme.spacing(2),
  // },

  footerText: {
    flex: 1,
    fontSize: 10,
  },

  footerLogo: {
    height: "auto",
    width: 100,
  },
  uid: {
    bottom: 2,
    left: VoTheme.spacing(4),
    position: "absolute",
  },
});
